export enum SsoEnum {
    Klipfolio = 'Klipfolio',
}